import React from "react";
import { Chip, ChipProps } from "@mui/material";

interface RewardPointsChipProps extends Omit<ChipProps, "label"> {
  points: number;
}

const RewardPointsChip: React.FC<RewardPointsChipProps> = ({ points, ...props }) => {
  const pluralize = (count: number, singular: string, plural: string) =>
    count === 1 ? singular : plural;

  return (
    <Chip
      color="warning"
      label={`${points} ${pluralize(points, "PT", "PTS")}`}
      sx={{
        borderRadius: 1,
        ...props.sx,
      }}
      size="small"
      {...props}
    />
  );
};

export default RewardPointsChip;
